import React, { useState, useEffect } from "react";
import FormField from "../../../components/ui/FormField";
import { Button } from "../../../components/Button";

const DEFAULT_ENTRY = {
    sNo: "",
    granteeName: "",
    optionsGranted: "",
    vestingDate: "",
    exercisedPeriod: "",
    exerciseDate: "",
    optionsExercised: "",
    exercisePrice: "",
    sharesArising: "",
    folioNo: "",
    lockinPeriod: "",
    optionLapsed: "",
    optionsInForce: "",
    forfeitedAmount: "",
    schemeVariation: "",
    signature: "",
    remarks: ""
};

const DEFAULT_COMPANY_INFO = {
    companyName: "",
    registeredOffice: "",
    specialResolutionDate: ""
};

const ShSixForm = () => {
    const [companyInfo, setCompanyInfo] = useState(() => {
    const saved = localStorage.getItem("sh6_company_info");
    return saved ? JSON.parse(saved) : { ...DEFAULT_COMPANY_INFO };
});


    const handleCompanyChange = (field, value) => {
        const updated = { ...companyInfo, [field]: value };
        setCompanyInfo(updated);
        localStorage.setItem("sh6_company_info", JSON.stringify(updated));
    };

  const [entries, setEntries] = useState(() => {
    const saved = localStorage.getItem("sh6_register_data");
    return saved
        ? JSON.parse(saved)
        : [{ id: Date.now(), ...DEFAULT_ENTRY }];
});

    useEffect(() => {
        localStorage.setItem("sh6_register_data", JSON.stringify(entries));
    }, [entries]);

    const updateField = (id, field, value) => {
        setEntries((prev) =>
            prev.map((entry) =>
                entry.id === id ? { ...entry, [field]: value } : entry
            )
        );
    };

   const addEntry = () => {
    setEntries(prev => [
        ...prev,
        { id: Date.now(), ...DEFAULT_ENTRY }
    ]);
};

const handleSave = () => {
    const payload = {
        formType: "SH-6",
        generatedAt: new Date().toISOString(),
        companyInfo,
        totalEntries: entries.length,
        registerEntries: entries.map(({ id, ...rest }) => rest)
    };

    console.log(
        "SH-6 REGISTER PAYLOAD:\n",
        JSON.stringify(payload, null, 2)
    );

    alert("SH-6 data saved. Open console to view JSON payload.");
};


    const deleteEntry = (id) => {
        if (entries.length > 1) {
            setEntries(entries.filter((e) => e.id !== id));
        }
    };

    return (
        <div>

            <div className="bg-white border-b-4 px-6 py-2 mb-2 text-center shadow-sm rounded-t-lg">
                <h1 className="text-2xl font-black uppercase tracking-tight">Form No. SH - 6</h1>
                <h2 className="text-xl font-bold mt-1">Register of Employee Stock Options</h2>
                <p className="text-[10px] italic text-slate-500 mt-2 max-w-3xl mx-auto">
                    [Pursuant to rule 12(10) of the Companies (Share Capital and Debentures) Rules, 2014]
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 bg-white p-6 rounded-lg shadow mb-2">
                <FormField
                    label="Name of Company"
                    value={companyInfo.companyName}
                    onChange={(v) => handleCompanyChange("companyName", v)}
                />
                <FormField
                    label="Registered Office Address"
                    value={companyInfo.registeredOffice}
                    onChange={(v) => handleCompanyChange("registeredOffice", v)}
                />
                <FormField
                    label="Date of Special Resolution"
                    type="date"
                    value={companyInfo.specialResolutionDate}
                    onChange={(v) => handleCompanyChange("specialResolutionDate", v)}
                />
            </div>

            <div className="space-y-2">
                {entries.map((entry, index) => (
                    <div
                        key={entry.id}
                        className="bg-white border border-slate-200 rounded-xl shadow-md overflow-hidden transition-all hover:shadow-lg"
                    >
                        <div className="bg-primary text-white px-6 py-3 flex justify-between items-center">
                            <span className="font-bold text-xs uppercase tracking-widest text-slate-200">
                                Record Entry No: {index + 1}
                            </span>
                            {entries.length > 1 && (
                                <button
                                    onClick={() => deleteEntry(entry.id)}
                                    className="text-[10px] bg-red-600 px-3 py-1 rounded hover:bg-red-700 font-bold uppercase transition"
                                >
                                    Remove Record
                                </button>
                            )}
                        </div>

                        <div className="p-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            <FormField label="(1) S.No" value={entry.sNo} onChange={(v) => updateField(entry.id, "sNo", v)} />
                            <FormField label="(2) Name of the grantee" value={entry.granteeName} onChange={(v) => updateField(entry.id, "granteeName", v)} />
                            <FormField label="(3) Number of options granted" value={entry.optionsGranted} onChange={(v) => updateField(entry.id, "optionsGranted", v)} />

                            <FormField label="(4) Date on which options vested" type="date" value={entry.vestingDate} onChange={(v) => updateField(entry.id, "vestingDate", v)} />
                            <FormField label="(5) Exercised period" value={entry.exercisedPeriod} onChange={(v) => updateField(entry.id, "exercisedPeriod", v)} />
                            <FormField label="(6) Date on which options exercised" type="date" value={entry.exerciseDate} onChange={(v) => updateField(entry.id, "exerciseDate", v)} />

                            <FormField label="(7) Options exercised" value={entry.optionsExercised} onChange={(v) => updateField(entry.id, "optionsExercised", v)} />
                            <FormField label="(8) Exercise price" value={entry.exercisePrice} onChange={(v) => updateField(entry.id, "exercisePrice", v)} />
                            <FormField label="(9) Number of shares arising as result of exercise of option" value={entry.sharesArising} onChange={(v) => updateField(entry.id, "sharesArising", v)} />

                            <FormField label="(10) Folio No." value={entry.folioNo} onChange={(v) => updateField(entry.id, "folioNo", v)} />
                            <FormField label="(11) Lock in period, if any" value={entry.lockinPeriod} onChange={(v) => updateField(entry.id, "lockinPeriod", v)} />
                            <FormField label="(12) Option lapsed, if any" value={entry.optionLapsed} onChange={(v) => updateField(entry.id, "optionLapsed", v)} />

                            <FormField label="(13) Total number of options in force" value={entry.optionsInForce} onChange={(v) => updateField(entry.id, "optionsInForce", v)} />
                            <FormField label="(14) Amount forfeited / refunded if option is not exercised" value={entry.forfeitedAmount} onChange={(v) => updateField(entry.id, "forfeitedAmount", v)} />
                            <FormField label="(15) Variation of scheme terms & effects" type="description" value={entry.schemeVariation} onChange={(v) => updateField(entry.id, "schemeVariation", v)} />

                            <FormField label="(16) Signature" value={entry.signature} onChange={(v) => updateField(entry.id, "signature", v)} />
                            <FormField label="(17) Remarks" type="description" value={entry.remarks} onChange={(v) => updateField(entry.id, "remarks", v)} />
                        </div>
                    </div>
                ))}
            </div>

            <Button
            label='Add New Entry'
                onClick={addEntry}
                className="mt-2 mr-2"
            />
            <Button
    label="Save SH-6 Register"
    onClick={handleSave}
    className="mt-2 ml-2"
/>

        </div>
        
    );
};

export default ShSixForm;
